import React, { useEffect, useState } from "react"
import {useTranslation} from "react-i18next";
import { withTranslation } from "react-i18next"

//i18n
import i18n from "../i18n"
import languages from "../locales/languages"
import usaFlag from "../assets/images/flags/usa.png";
import geFlag from "../assets/images/flags/ge.png";

const LanguageDropdown = () => {

    const {t, i18n} = useTranslation();
    const [selectedLang, setSelectedLang] = useState("")

    useEffect(() => {
        const currentLanguage = localStorage.getItem("i18nextLng")
        setSelectedLang(currentLanguage)
    }, [])

    const changeLanguage = () => {
   /*     let lang = selectedLang

        if (lang === 'en') {
            i18n.changeLanguage('ka')
            setSelectedLang('ka')
            localStorage.setItem("i18nextLng", 'ka')
        }else {
            i18n.changeLanguage('en')
            setSelectedLang('en')
            localStorage.setItem("i18nextLng", 'en')
        }*/

    }

    return (
        <>

            <div className="header-btn" onClick={() => changeLanguage()}>
                {
                    selectedLang === 'en'
                        ? <img src={usaFlag} style={{height: '25px'}}/>
                        : <img src={usaFlag} style={{height: '25px'}}/>
                }

            </div>
        </>
    )
}

export default withTranslation()(LanguageDropdown)
